export enum BID_UPDATE_TYPE {
    WAITING = 0,
    NEGOTIATE = 1,
    ACCEPT = 2,
    EDIT = 3,
    REJECT = 4,
    VERIFY = 5,
    EXPIRE = 6,
    DECLINE = 7
}
